import React, { useState } from 'react';
import '../../entrydoor.css';

const JambMaterial = ({ value, onChange, label = 'Jamb Material:' }) => {
    const [selectedJambMaterial, setSelectedJambMaterial] = useState(value || "");

    const handleJambMaterialChange = (e) => {
        setSelectedJambMaterial(e.target.value);
        onChange(e.target.value);
        //alert(e.target.value)
        
        const element = document.getElementById("JambMaterialCompositeWarning");
            if (element){
                if (e.target.value === 'Composite'){
                    element.style.display = "block";
                }
                else{
                    element.style.display = "None";
                    //alert(e.target.value)
                }
            }
    
    };

    return (
        <div className="a-container">
            <label htmlFor="JambMaterial">{label}</label>
            <select
                id="JambMaterial"
                value={selectedJambMaterial}
                onChange={handleJambMaterialChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Laminated">{selectedJambMaterial === "Laminated" ? 'Laminated ✔' : 'Laminated'}</option>
                <option value="Composite">{selectedJambMaterial === "Composite" ? 'Composite ✔' : 'Composite'}</option>
            </select>
            <div className = "jamb-warning" id="JambMaterialCompositeWarning"  style={{ display: 'none' }}  >
            
            Please Note: Composite Jambs and Brickmould must be Painted/Stained Inside and Out
            
            </div>
        </div>
    );
};

export default JambMaterial;
